import { render, staticRenderFns } from "./Fishcar.vue?vue&type=template&id=6383d076"
import script from "./Fishcar.vue?vue&type=script&lang=js"
export * from "./Fishcar.vue?vue&type=script&lang=js"
import style0 from "./Fishcar.vue?vue&type=style&index=0&id=6383d076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports